module.exports = __webpack_public_path__ + "img/ev-logo.58942697.svg";